<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'DSeoTitleEditor',
  extends: compoment
}
</script>
